import { useCallback, useMemo } from 'react';
import { createTeleporter } from 'react-teleporter';
import DashletMenu from '../DashletMenu';

const DashletMenuController = ({
  dashlet,
  onShowEditModal,
  onDeleteDashlet,
  onRenameHandler,
  onDuplicateHandler,
  overrideEditHandler,
  entity,
}) => {
  const DashletMenuContents = useMemo(createTeleporter, []);
  const DashletAction = useMemo(createTeleporter, []);

  const onDeleteHandler = useCallback(() => {
    return onDeleteDashlet(dashlet.dashboard, dashlet.id);
  }, [dashlet, onDeleteDashlet]);

  return (
    <>
      <DashletAction.Target className="dashlet-action" />
      <DashletMenu
        onDeleteHandler={onDeleteHandler}
        onEditHandler={onShowEditModal}
        onDuplicateHandler={onDuplicateHandler}
        onRenameHandler={onRenameHandler}
        id={dashlet.id}
        entity={entity}
      >
        <DashletMenuContents.Target />
      </DashletMenu>
    </>
  );
};

export default DashletMenuController;
